/*
 * Purpose: Route-level analytics — page views + periodic flush
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { flushAnalytics, trackPageView, trackSessionStart } from '@/lib/siteAnalytics';
import { hasAnalyticsConsent } from '@/lib/analyticsConsent';

export function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!hasAnalyticsConsent() || !['/', '/pricing', '/status'].includes(pathname)) return;

    const siteId = 'c5bbb4fb-4e45-4162-a803-d85ec99a0500';
    if (document.querySelector(`script[data-site="${siteId}"]`)) return;

    const tracker = document.createElement('script');
    tracker.defer = true;
    tracker.src = 'https://usage.teknoledg.com/t.js';
    tracker.dataset.site = siteId;
    tracker.dataset.includePaths = '/,/pricing,/status';
    tracker.dataset.ignoreQuery = 'true';
    document.head.appendChild(tracker);
  }, [pathname]);

  useEffect(() => {
    if (!hasAnalyticsConsent()) return;
    trackSessionStart();
    const interval = window.setInterval(() => void flushAnalytics(), 15000);
    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!hasAnalyticsConsent()) return;
    trackPageView(pathname);
    void flushAnalytics();
  }, [pathname]);

  return null;
}
